const ReportsConstantsAR = {
  reportsTitle: 'التقارير',
  generateReportTitle: 'إنشاء تقرير',
  generateReportSubtitle: 'اختر نوع التقرير والنطاق الزمني وأرسله',
  reportsStartDate: 'إبتداءاً من',
  reportsEndDate: 'إنتهاءاً بـ',
  topSellingMediaReport: 'المواد الأكثر مبيعًا',
  top10CustomersReport: 'أفضل 10 عملاء',
  auditLogReport: 'سجل التدقيق',
  top10SearchesReport: 'أعلى 10 عمليات بحث',
  allSearchReport: 'كل عمليات البحث',
  reportDetailsTitle: 'أكثر المواد مبيعًا',
  topSellingRank: 'الترتيب',
  topSellingMediaTitle: 'عنوان الفيديو',
  topSellingNumOfPurchase: 'عدد مرات الشراء',
  auditDate: 'التاريخ والوقت',
  eventType: 'نوع الحدث',
  performedBy: 'تمت بواسطة',
  itemAffected: 'العنصر المتأثر',
  create: 'إنشاء',
  update: 'تحديث',
  delete: 'حذف',
  saymaSystem: 'نظام سيما',
  adminUserEntity: 'المستخدمون الإداريون',
  approvedDomainEntity: 'النطاقات المعتمدة',
  mediaEntity: 'الوسائط',
  systemSettingsEntity: 'إعدادات النظام',
  userShoppingCart: 'سلة التسوق للمستخدمين',
  userOrderEntity: 'طلبات المستخدمين',
  userInvoiceEntity: 'إيصالات المستخدمين',
  termsAndConditions: 'الشروط والأحكام',
  cookiesPolices: 'سياسة الخصوصية و سياسة ملفات تعريف الإرتباط',
  privacyPolicy: 'سياسة الخصوصية',
  faqs: 'الأسئلة الشائعة',
  blog: 'المدونة',
  successStories: 'قصص النجاح',
  news: 'الأخبار',
  aboutUs: 'من نحن',
  checkoutTermsAndConditions: 'شروط وأحكام الدفع',
  searchTerm: 'مصطلح البحث',
  searchCount: 'عدد مرات البحث',
  rank: 'الترتيب',
  title: 'العنوان',
  total: 'عدد مرات البحث',
  topCustomerUserName: 'إسم الزبون',
  topCustomerHighestOrderAmount: 'أعلى قيمة للطلب',
  topCustomerTitle: 'أفضل 10 عملاء',
  errorPeriodDateMsg: 'نطاق تاريخ غير صالح. يرجى اختيار تواريخ بداية ونهاية صالحة.',
  customerName: 'اسم العميل',
  highestOrderValue: 'أعلى قيمة طلب',

  mediaExclusivity: 'حصرية المواد',
  mediaExclusivityReferenceId: 'الرقم المرجعي',
  mediaExclusivityRightTypes: 'الحقوق',
  mediaExclusivityExclusivityTypes: 'الحصرية',
  mediaExclusivityLicensePeriods: 'مدة الترخيص',
  mediaExclusivityExclusiveMedia: 'حصري',
  mediaExclusivityHoldbackMedia: 'إحتجاز',
  mediaExclusivityMediaTitle: 'اسم الفيديو',
};

export default ReportsConstantsAR;
